var _circle, _rect, _rect2, _rect3, _rect4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "url(#paint0_linear_1827_60127)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 5,
    height: 1.5,
    fill: "#E5E4EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.0137,
    width: 7,
    height: 1.5,
    fill: "#E5E4EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 9,
    height: 1.5,
    fill: "#E5E4EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 4,
    width: 14,
    height: 1.5,
    transform: "rotate(90 9.5 4)",
    fill: "#E5E4EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.5137C13.0026 12.5137 13.0052 12.5137 13.0078 12.5137C15.355 12.5137 17.2578 10.6109 17.2578 8.26367C17.2578 5.91646 15.355 4.01367 13.0078 4.01367C13.0052 4.01367 13.0026 4.01367 13 4.01368V5.51368C13.0026 5.51368 13.0052 5.51367 13.0078 5.51367C14.5266 5.51367 15.7578 6.74489 15.7578 8.26367C15.7578 9.78245 14.5266 11.0137 13.0078 11.0137C13.0052 11.0137 13.0026 11.0137 13 11.0137V12.5137Z",
    fill: "#E5E4EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1827_60127",
    x1: 3.25926,
    y1: 3.4375,
    x2: 21.2182,
    y2: 24.7222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/coin.f887152d6ec084221c2c7f039bf779f6.svg";